import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

export const Title = styled.h2`
    ${({ theme }) => theme.typography.Subheadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-bottom: 16px;
`;

export const PaymentMethodsWrap = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
`;

export const AddNewButton = styled(ButtonV2)`
    margin-bottom: 16px;
`;

export const AddLabel = styled.span`
    ${(props) => props.theme.typography.Paragraph};
`;

export const ControlsWrap = styled.div`
    display: flex;
    margin-top: auto;
`;

export const BackButton = styled(ButtonV2)`
    margin-right: 16px;
    min-width: 120px;
`;

export const ContinueButton = styled(ButtonV2)``;
